// extracted by mini-css-extract-plugin
module.exports = {"testIFrame":"admin-portal-frame__IFrame__testIFrame"};